<template>
  <button :class="[classes, { disabled }]" @click="$emit('triggerAction')">
    <base-icon-save v-if="showSaveIcon"></base-icon-save>
    {{ label }}
  </button>
</template>

<script>
export default {
  props: {
    disabled: {
      type: Boolean,
      default: false,
    },
    classes: {
      type: String,
      default: 'btn btn-primary d-flex align-items-center gap-2',
    },
    label: {
      type: String,
      default: 'Speichern',
    },
    showSaveIcon: {
      type: Boolean,
      default: false,
    },
  },
  emits: ['triggerAction'],
  setup() {
    return {};
  },
};
</script>
